import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ItemProdutoResumoJanelaComponent } from './item-produto-resumo-janela.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: ItemProdutoResumoJanelaComponent}
  ])],
  exports: [RouterModule]
})
export class ItemProdutoResumoJanelaRoutingModule { }
